import { useCachedData } from '../hooks/useCachedData';
import { endpoints } from '../api/config';
import { DataGridPro } from '@mui/x-data-grid-pro';
import HoverExpandDataGridPro from '../components/HoverExpandDataGridPro';
import { useDataGridProTable, MuiXDataGridSurface } from '../hooks/useDataGridProTable';
import DashboardLayout from '../components/DashboardLayout';
import { useMemo, useState, useEffect } from 'react';

const Items = () => {
  const { data, isLoading, error, refetch } = useCachedData(endpoints.items);
  const [columnVisibility, setColumnVisibility] = useState(() => {
    const saved = localStorage.getItem('items-column-visibility');
    return saved ? JSON.parse(saved) : {};
  });

  // Save column visibility to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('items-column-visibility', JSON.stringify(columnVisibility));
  }, [columnVisibility]);

  // Define columns for the table
  const columns = useMemo(() => [
    { 
      accessorKey: 'id', 
      header: 'ID',
      minSize: 200,
      size: 220,
      enableSorting: true
    },
    { 
      accessorKey: 'name', 
      header: 'Name',
      minSize: 200,
      size: 220,
      enableSorting: true
    },
    { 
      accessorKey: 'upc_code', 
      header: 'UPC Code',
      minSize: 200,
      size: 220,
      enableSorting: true
    }
  ], []);

  // Transform the data to include numeric keys as IDs
  const tableData = useMemo(() => {
    if (!data) return [];
    
    // If data is an object with numeric keys
    if (typeof data === 'object' && !Array.isArray(data)) {
      return Object.entries(data).map(([key, value]) => ({
        id: key,
        name: value.name,
        upc_code: value.upc_code
      }));
    }
    
    return data;
  }, [data]);

  const appGrid = useDataGridProTable({
    data: tableData,
    loading: isLoading,
    error: error ? error.message || 'Failed to load items' : null,
    title: 'Items',
    columns,
    onDataRefresh: refetch,
    initialColumnVisibility: columnVisibility,
    onColumnVisibilityChange: setColumnVisibility,
    initialSorting: [{ id: 'id', desc: false }],
  });

  return (
    <DashboardLayout>
      <MuiXDataGridSurface hook={appGrid} DataGridPro={DataGridPro} />
    </DashboardLayout>
  );
};

export default Items; 